import { useTranslation } from 'react-i18next';
import { Box, LinearProgress, Typography } from '@mui/material';

const TaskProgress = ({ progress }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 1 }}>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{ height: 6, borderRadius: 3 }}
      />
      <Typography variant="caption" color="textSecondary">
        {progress}% {t('ActivityCenter_Status_Complete')}
      </Typography>
    </Box>
  );
};

export default TaskProgress;
